import React from 'react';
import CarParallaxAnimation from '../components/CarParallaxAnimation';

function PresentationPage() {
  return (
    <div className="relative">
      <CarParallaxAnimation />
    </div>
  );
}

export default PresentationPage;